const STRUCT = {
  ID: 'id',
  NAME: 'title',
  DESC: 'description',
};

export default STRUCT;
